module.exports = __webpack_public_path__ + "img/banner-GBTA-BNO.d4ab8f5b.png";